import { render, staticRenderFns } from "./Kasa.vue?vue&type=template&id=2c49ca12"
import script from "./Kasa.vue?vue&type=script&lang=js"
export * from "./Kasa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports